// extracted by mini-css-extract-plugin
module.exports = {"text":"MessageView_text__CW8KO","textWarning":"MessageView_textWarning__O0yKR","resolution":"MessageView_resolution__2_ic-"};